import React, { useState } from 'react';
import { OverlayTrigger, Tooltip, Badge, Button, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FaSync } from 'react-icons/fa';

// Import the services to get the actual URLs being used
import { getApiUrl } from '../../services/apiService';
import { getWebSocketUrlForDisplay } from '../../hooks/useGlobalWebSocket';
import { refreshAllCrudData } from '../../utils/cacheUtils';

// Extract domain name for display
const getDisplayUrl = (url) => {
  try {
    // Remove protocol and get domain
    return url.replace(/^(https?|wss?):\/\//, '').split('/')[0];
  } catch (error) {
    return url;
  }
};

const ConnectionInfo = () => {
  const dispatch = useDispatch();
  const [refreshing, setRefreshing] = useState(false);

  // Get the actual URLs being used by the services
  const apiUrl = getApiUrl();
  const wsUrl = getWebSocketUrlForDisplay();

  const apiDisplay = getDisplayUrl(apiUrl);
  const wsDisplay = getDisplayUrl(wsUrl);

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await refreshAllCrudData(dispatch);
    } catch (error) {
      console.error('Error refreshing data:', error);
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <div className="d-flex align-items-center me-3">
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="connection-info-tooltip">
            <div><strong>API:</strong> {apiUrl}</div>
            <div><strong>WebSocket:</strong> {wsUrl}</div>
          </Tooltip>
        }
      >
        <div className="d-flex align-items-center me-2">
          <Badge bg="secondary" className="connection-info-badge me-2 px-2" style={{ height: '24px', display: 'flex', alignItems: 'center', padding: '0 0.5rem' }}>
            <span>API: {apiDisplay}</span>
          </Badge>
          <Badge bg="secondary" className="connection-info-badge px-2" style={{ height: '24px', display: 'flex', alignItems: 'center', padding: '0 0.5rem' }}>
            <span>WS: {wsDisplay}</span>
          </Badge>
        </div>
      </OverlayTrigger>

      <Button
        variant="outline-secondary"
        size="sm"
        onClick={handleRefresh}
        disabled={refreshing}
        className="d-flex align-items-center"
      >
        {refreshing ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <FaSync />
        )}
      </Button>
    </div>
  );
};

export default ConnectionInfo;
